export default "__VITE_ASSET__8db0c708__"